import React from "react";
import classes from "./ProjectGroupCard.scss";

const ProjectGroupCard = props => {
  const { label, onCardClick, subtext, containerStyle } = props;
  return (
    <div
      className={classes.container}
      style={containerStyle}
      onClick={onCardClick}
    >
      <span className={classes.labelText}>{label}</span>
      {subtext && <span>{subtext}</span>}
    </div>
  );
};

export default ProjectGroupCard;
